import {
    Component,
    forwardRef,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RegExPattern } from '../../../../core/models/regexp-pattern/regex-pattern';
import {
    ControlValueAccessor,
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { StateProvince } from '../../../../core/services/resources/models/state-province';
import { lastValueFrom } from 'rxjs';
import { ResourcesService } from '../../../../core/services/resources/resources.service';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'app-state-province-input',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
    ],
    templateUrl: './state-province-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StateProvinceInputComponent),
            multi: true,
        },
    ],
})
export class StateProvinceInputComponent
    implements ControlValueAccessor, OnInit
{
    stateProvinceId: string = '';
    stateProvinces: StateProvince[] = [];

    regExPattern = RegExPattern;

    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    constructor(private readonly resourcesService: ResourcesService) {}

    ngOnInit(): void {
        this.getStateProvinces().then((stateProvinces) => {
            this.stateProvinces = stateProvinces;
        });
    }

    /**
     * Fetches the list of state provinces from the server and sets the state provinces array.
     */
    private getStateProvinces(): Promise<StateProvince[]> {
        return lastValueFrom(this.resourcesService.getStateProvinces());
    }

    writeValue(value: string): void {
        this.stateProvinceId = value;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    onInputChange(value: string): void {
        this.onChange(value);
        this.onTouched();
    }
}
